import { Button, Modal } from "react-bootstrap";

export interface Props {
    children: React.ReactNode;
    onClose: () => void;
}

export function AlertDialog({ children, onClose }: Props) {
    return (
        <Modal show>
            <Modal.Body>{children}</Modal.Body>
            <Modal.Footer>
                <Button variant="default" onClick={onClose}>
                    OK
                </Button>
            </Modal.Footer>
        </Modal>
    );
}
